import { useParams } from 'react-router-dom';
import DashboardViewer from '../dashboard-v1/DashboardViewer';

const DashboardTab = ({ location }) => {
  const params = useParams();
  const locationId =
    location?.id || params.id || params['*']?.split('/').filter(Boolean)[0];

  return <DashboardViewer locationId={locationId} />;
};

export default DashboardTab;
